import React, { useEffect, useState, useContext } from "react";
import { CustomInput } from "../../../assets/CustomInput/CustomInput";
import styles from "../../shared/ProgressReport.module.scss";
import { IndividualWorkPlanContext } from "../../../utils/context";

export default function Main({ getPdf }) {
  const { id, individualWorkPlanTab } = useContext(IndividualWorkPlanContext);
  const [individ, setIndivid] = useState({});

  useEffect(() => {
    if (individualWorkPlanTab?.length) {
      setIndivid(individualWorkPlanTab[0]);
    }
  }, [individualWorkPlanTab]);

  const {
    fio,
    syname,
    discussed,
    protocol_number,
    sign_date,
    status,
    performed,
    verified,
    approved,
    protocol_date,
    position,
    cathedra,
  } = individ || {};

  return (
    individualWorkPlanTab && (
      <div className="faculty_main" style={{ paddingTop: "90px" }}>
        <h3>Индивидуальный план работы на {syname || ""} учебный год</h3>

        <div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
            <CustomInput label="Сотрудник:" width="30%" value={fio || ""} disabled />
            <CustomInput label="Должность:" width="30%" value={position || ""} disabled />
            <CustomInput label="Кафедра:" width="30%" value={cathedra || ""} disabled />
            <CustomInput label="Учебный год:" width="10%" value={syname || ""} disabled />
          </div>

          <br />

          {/* ✅ Чекбокс "Обсужден на заседании" */}
          <div className={styles.checkboxGroup}>
            <label className={styles.checkboxLabel}>
              <input type="checkbox" checked={!!discussed} disabled />
              Обсужден на заседании
            </label>
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
            <CustomInput
              label="Номер протокола:"
              width="70%"
              value={protocol_number || ""}
              disabled
            />
            <CustomInput
              label="Дата протокола:"
              type="date"
              width="20%"
              value={protocol_date ? protocol_date.split("T")[0] : ""}
              disabled
            />
          </div>

          {/* ✅ Остальные статусы теперь чекбоксы */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "2rem",
              marginTop: "1rem",
            }}
          >
            <label className={styles.checkboxLabel}>
              <input type="checkbox" checked={!!approved} disabled />
              Утвержден
            </label>

            <label className={styles.checkboxLabel}>
              <input type="checkbox" checked={!!performed} disabled />
              Выполнен
            </label>

            <label className={styles.checkboxLabel}>
              <input type="checkbox" checked={!!verified} disabled />
              Проверен
            </label>
          </div>

          <div style={{ marginTop: "1rem", width: "30%" }}>
            <CustomInput label="Статус:" value={status || ""} disabled />
          </div>

          <div style={{ marginTop: "1rem", width: "30%" }}>
            <CustomInput
              label="Дата подписания:"
              type="date"
              value={sign_date || ""}
              disabled
            />
          </div>
        </div>

        {getPdf()}
      </div>
    )
  );
}
